import React, { useState } from 'react';
import TertiaryCustomButton from '../../../../../commons/tertiary-custom-button/tertiary-custom-button';
// import React, { useState } from "react";
// import TertiaryCustomButton from "../TertiaryCustomButton";

export default function RegionItem({ item, onNext }) {
  const { regions = [], view_all } = item.content;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(null);

  // Toggle main menu open on heading click
  const toggleMenuOpen = () => {
    // console.log('regions', regions);
    onNext(regions, item.title);
  };

  // Category button click: activate category, call onNext
  const handleCategoryClick = (index, category) => {
    // console.log('category', regions);
    // console.log('regions category.items', category.items);
    setActiveCategoryIndex(index);
    // console.log('useEffect item.title', item.title);
    onNext(category.items, item.title, '');
  };

  // const order = ["United States", "Asia", "North America", "Europe", "Oceania"];

  // function reorderRegions(data, order) {
  //   return order
  //     .map(title => data.find(item => item.title === title))
  //     .filter(Boolean); // removes any not found
  // }
  // const reorderedData = reorderRegions(regions, order);
  // console.log('currentTitle formatRegions main', reorderedData)
  return (
    <li className="category-item">
      <TertiaryCustomButton
        title={item.title}
        onClick={toggleMenuOpen}
        classes={'customize-tertiary-cls'}
      />

      {isMenuOpen && (
        <div className="industries-menu">
          <div
            className="industries-buttons"
            style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
            {regions.map((cat, idx) => (
              <TertiaryCustomButton
                key={idx}
                classes={`customize-tertiary-cls ${
                  activeCategoryIndex === idx ? 'active' : ''
                }`}
                title={cat.title}
                onClick={() => {
                  // console.log('category ', cat);
                  handleCategoryClick(idx, cat);
                }}
              />
            ))}
          </div>

          {/* Show sub-items of active category */}
          {activeCategoryIndex !== null && (
            <div className="dropdown-items" style={{ marginTop: '1rem' }}>
              <h4>{regions[activeCategoryIndex].title}</h4>
              <ul>
                {regions[activeCategoryIndex].items.map((subItem, i) => (
                  <li key={i}>
                    <a href="#" className="menu-link">
                      {subItem}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* View all industries link */}
          {view_all && (
            <div className="view-all" style={{ marginTop: '1rem' }}>
              <a href={view_all.href}>{view_all.text}</a>
            </div>
          )}
        </div>
      )}
    </li>
  );
}
